"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
let defaultTestMode = false;
// try {
if (window && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname.startsWith("localhost")))
    defaultTestMode = true;
// }
// catch(e) {
//   if( e instanceof ReferenceError )
//     defaultTestMode = false
//   else
//     throw e
// }
let overrideTestMode;
class Config {
    static get testMode() {
        return overrideTestMode !== null && overrideTestMode !== void 0 ? overrideTestMode : defaultTestMode;
    }
    static set testMode(value) {
        overrideTestMode = value;
    }
}
exports.Config = Config;
//# sourceMappingURL=Config.js.map